import { render } from "./ComponentContact.vue?vue&type=template&id=0d0eb854"
import script from "./ComponentContact.vue?vue&type=script&lang=js"
export * from "./ComponentContact.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__